import { createContext, useContext, type ReactNode } from 'react';

import { fetchReferenceAssistantGateway } from '../api/fetchReferenceAssistantGateway';
import type { ReferenceAssistantGateway } from '../ports/referenceAssistantGateway';

/**
 * Which backend the reference assistant's hooks talk to. It defaults to the
 * real one, so the app mounts no provider; a test mounts one holding an
 * in-memory gateway.
 */
const ReferenceAssistantGatewayContext = createContext<ReferenceAssistantGateway>(
  fetchReferenceAssistantGateway
);

export function ReferenceAssistantGatewayProvider({
  gateway,
  children,
}: {
  gateway: ReferenceAssistantGateway;
  children: ReactNode;
}) {
  return (
    <ReferenceAssistantGatewayContext.Provider value={gateway}>
      {children}
    </ReferenceAssistantGatewayContext.Provider>
  );
}

export function useReferenceAssistantGateway() {
  return useContext(ReferenceAssistantGatewayContext);
}
